import { createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createVNode as _createVNode, Fragment as _Fragment, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-aabff04a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "section-row" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, [
  /*#__PURE__*/_createElementVNode("p", null, "기점출발")
], -1 /* HOISTED */))
const _hoisted_3 = ["aria-label"]
const _hoisted_4 = { class: "departure-times" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = {
  key: 1,
  class: "empty-turn"
}
const _hoisted_7 = { key: 1 }
const _hoisted_8 = {
  key: 1,
  class: "empty-turn"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, [
  /*#__PURE__*/_createElementVNode("p", null, "운행시간")
], -1 /* HOISTED */))
const _hoisted_10 = { class: "content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("section", null, [
    _createElementVNode("div", _hoisted_1, [
      (!$props.isInsideShuttle)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _hoisted_2,
            _createElementVNode("button", {
              class: "selectable-area",
              type: "button",
              onClick: $setup.onClickSelectTime,
              "aria-label": 
            $props.hasDifferentTimes
              ? '기점 출발 시간 선택'
              : '기점 출발 시간(선택 불가)'
          
            }, [
              _createElementVNode("div", _hoisted_4, [
                ($setup.shouldShowTurnList)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                      ($setup.previousDisplayTurnIndex !== undefined)
                        ? (_openBlock(), _createBlock($setup["LineInfoDetailDepartureTime"], {
                            key: 0,
                            class: "previous-turn",
                            lineInfo: $props.lineInfo,
                            turnIndex: $setup.previousDisplayTurnIndex,
                            departureTime: $props.availableTimes[$setup.previousDisplayTurnIndex]
                          }, null, 8 /* PROPS */, ["lineInfo", "turnIndex", "departureTime"]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_6))
                    ]))
                  : _createCommentVNode("v-if", true),
                _createVNode($setup["LineInfoDetailDepartureTime"], {
                  class: "current-turn",
                  lineInfo: $props.lineInfo,
                  turnIndex: $setup.selectedTurnIndex,
                  departureTime: $props.availableTimes[$setup.selectedTurnIndex],
                  hasDifferentTimes: $props.hasDifferentTimes,
                  onOnClickSelectTime: $setup.onClickSelectTime
                }, null, 8 /* PROPS */, ["lineInfo", "turnIndex", "departureTime", "hasDifferentTimes"]),
                ($setup.shouldShowTurnList)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                      ($setup.nextDisplayTurnIndex !== undefined)
                        ? (_openBlock(), _createBlock($setup["LineInfoDetailDepartureTime"], {
                            key: 0,
                            class: "next-turn",
                            lineInfo: $props.lineInfo,
                            turnIndex: $setup.nextDisplayTurnIndex,
                            departureTime: $props.availableTimes[$setup.nextDisplayTurnIndex]
                          }, null, 8 /* PROPS */, ["lineInfo", "turnIndex", "departureTime"]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_8))
                    ]))
                  : _createCommentVNode("v-if", true)
              ])
            ], 8 /* PROPS */, _hoisted_3)
          ], 64 /* STABLE_FRAGMENT */))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _hoisted_9,
            _createElementVNode("button", {
              class: "selectable-area shuttle",
              type: "button",
              onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.emit('showBusTimeTable'))),
              "aria-label": "운행시간표 보기"
            }, [
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("p", null, _toDisplayString($setup.getAvailableTimeStr), 1 /* TEXT */),
                _createCommentVNode(" <div\n              v-if=\"currentTurn.earlyDriveInfos?.length\"\n              class=\"early-drive-info\"\n            >\n              <template\n                v-for=\"(earlyDriveInfo, index) in currentTurn.earlyDriveInfos\"\n                :key=\"index\"\n              >\n                <div class=\"weekday\">\n                  <span>{{ earlyDriveInfo.weekdayName }}</span>\n                  <span v-if=\"earlyDriveInfo.earlyMinute\" class=\"early-time\">\n                    {{ getEarlyDriveTime(earlyDriveInfo.earlyMinute) }}\n                  </span>\n                </div>\n              </template>\n            </div> ")
              ])
            ])
          ], 64 /* STABLE_FRAGMENT */))
    ])
  ]))
}